import {Link, useLocation} from 'react-router-dom'
import React from "react"

export const LocationAwareLink = (props: { children: React.ReactNode, to: string, className?: string }) => {
    const {pathname} = useLocation()
    const {to, className, children} = props;
    const from_url = window.location.href;


    const classNames = className + " " + (pathname === to ? "active" : "")

    return (
        <Link to={to} className={classNames} state={{ from_url: from_url }}>
            {children}
        </Link>
    )
}
